import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { LanguageProvider } from './context/LanguageContext';
import { AnalyticsProvider } from './context/AnalyticsContext';
import { ExitIntentModal } from './components/ExitIntentModal';
import { ConsentGate } from './components/ConsentGate';
import { FounderPortal } from './components/FounderPortal';
import { DealSourcingAgent } from './components/DealSourcingAgent';
import { useEnhancedAnalytics } from './hooks/useEnhancedAnalytics';
import { googleSheetsSync } from './utils/googleSheetsSync';
function AppContent() {
  const {
    hasConsent,
    handleConsent
  } = useEnhancedAnalytics();
  const [showConsentGate, setShowConsentGate] = useState(false);
  useEffect(() => {
    const consent = localStorage.getItem('consent_record');
    if (!consent) {
      setTimeout(() => setShowConsentGate(true), 500);
    }
  }, []);
  useEffect(() => {
    if (hasConsent) {
      console.log('[App] 🚀 Starting Google Sheets sync');
      googleSheetsSync.startAutoSync();
      return () => {
        googleSheetsSync.stopAutoSync();
      };
    }
  }, [hasConsent]);
  const handleConsentSubmit = (agreed: boolean) => {
    handleConsent(agreed, undefined);
    setShowConsentGate(false);
  };
  return <>
      {showConsentGate && !hasConsent && <ConsentGate onConsent={handleConsentSubmit} language="en" data-id="element-0" />}

      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/privacy-policy" element={<PrivacyPolicy data-id="element-6" />} data-id="element-5" />
        </Routes>
        <ExitIntentModal data-id="element-7" />
      </BrowserRouter>

      <FounderPortal data-id="element-8" />
      <DealSourcingAgent data-id="element-9" />
    </>;
}
export function App() {
  return <LanguageProvider data-id="element-10">
      <AnalyticsProvider data-id="element-11">
        <AppContent data-id="element-12" />
      </AnalyticsProvider>
    </LanguageProvider>;
}